import { Box } from '../Box'
import { TABLE_CELL_FONT_VARIANTS } from '../../../constants'
import { TableCellProps } from '../../..'
import { border, color, display, padding, position, textAlign, variant, width } from 'styled-system'
import styled from 'styled-components'

type TableCellBaseProps = TableCellProps & { hasIcon: boolean }

export const TableCellBase = styled.td<TableCellBaseProps>`
  padding: ${({ hasIcon, type }) => (hasIcon && type !== 'sort' ? '13px 12px' : '22px 20px')};
  width: ${({ hasIcon, type }) => (hasIcon && type !== 'sort' ? '44px' : 'auto')};
  cursor: ${({ cursor, type }) => (type ? 'pointer' : cursor || 'inherit')};
  text-align: left;
  ${variant({
    prop: 'fontVariant',
    variants: { ...TABLE_CELL_FONT_VARIANTS }
  })};
  ${textAlign}
  ${padding}
  ${width}
  ${display}
  ${position}
  ${border}
`

export const TableCellIconBase = styled(Box)<TableCellProps>`
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  height: 44px;
  width: 44px;
  ${border}
  ${color}
`
